export default "__VITE_ASSET__unrCdC9v__"